import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { styled } from "@mui/material/styles";
import Button from "@mui/material/Button";
import Popper from "@mui/material/Popper";
import BryxColors from "../types/theme";
import BryxIcon from "./BryxIcon/BryxIcon";
import { Box, ClickAwayListener } from "@mui/material";
import { dropKeys } from "@bryxinc/ts-utils";
import { useState } from "react";
const BryxPopperButton = styled(({ setAnchorEl, icon, label, ...rest }) => {
    return (_jsx(Button, { ...dropKeys(rest, ["anchorEl", "id", "open"]), ref: setAnchorEl, disableRipple: true, startIcon: _jsx(BryxIcon, { iconName: icon, smIconSize: true }), children: label }));
})(({ open, theme }) => {
    const lightMode = theme.palette.mode == "light";
    return {
        fontSize: "13px",
        padding: "8px 16px",
        border: "none",
        boxShadow: "none",
        fontWeight: 400,
        lineHeight: "18px",
        textTransform: "none",
        fontStyle: "normal",
        color: lightMode
            ? open
                ? BryxColors.brandPrimary(theme.palette.mode)
                : BryxColors.brandDark2(theme.palette.mode)
            : open
                ? BryxColors.brand1(theme.palette.mode)
                : BryxColors.brand4(theme.palette.mode),
        backgroundColor: `${open ? (lightMode ? BryxColors.brand3(theme.palette.mode) : BryxColors.brandDark1(theme.palette.mode)) : "transparent"}`,
        "&:hover": {
            color: `${lightMode ? BryxColors.brand1(theme.palette.mode) : BryxColors.brand2(theme.palette.mode)}`,
            boxShadow: "none",
            backgroundColor: `${open ? (lightMode ? BryxColors.brand3(theme.palette.mode) : BryxColors.brandDark1(theme.palette.mode)) : "transparent"}`,
        },
        "&:active": {
            boxShadow: "none",
            color: BryxColors.brandPrimary(theme.palette.mode),
        },
    };
});
const BryxPopperBox = styled((props) => {
    return (_jsx(Box, { ...props, sx: { py: 2, px: 1, boxShadow: 3, borderRadius: "4px" }, children: props.children }));
})(({ theme }) => {
    const lightMode = theme.palette.mode == "light";
    return {
        backgroundColor: `${lightMode ? "#FFFFFF" : BryxColors.darkModePopupBackground()}`,
    };
});
const BryxPopperPopper = (props) => {
    return (_jsxs(Popper, { ...props, placement: "bottom-start", children: [_jsx(Box, { sx: { py: 1, px: 3 } }), _jsx(BryxPopperBox, { children: props.children })] }));
};
const BryxPopper = (props) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const [open, setOpen] = useState(props.defaultOpen || false);
    const handleClickAway = () => {
        setOpen(false);
    };
    return (_jsx(ClickAwayListener, { onClickAway: handleClickAway, children: _jsxs("div", { style: props.style, children: [_jsx(BryxPopperButton, { icon: props.icon, label: props.label, anchorEl: anchorEl, setAnchorEl: setAnchorEl, onClick: (event) => {
                        setAnchorEl(event.currentTarget);
                        setOpen((prev) => !prev);
                    }, open: anchorEl != null && open }), _jsx(BryxPopperPopper, { id: open ? "simple-popper" : undefined, open: anchorEl != null && open, anchorEl: anchorEl, children: props.children, sx: { zIndex: 1000 } })] }) }));
};
export default BryxPopper;
